import { ReportContext } from '../../../context/ReportContext';
import { useReportQueries } from './LandingPage/useReportQueries';

/**
 * Wrapper component that provides ReportContext to all /Reports/* routes
 * Fetches report data once and makes it available via context
 */
const ReportsWrapper = ({ children }) => {
  const reportData = useReportQueries();

  return (
    <ReportContext.Provider value={reportData}>
      {children}
    </ReportContext.Provider>
  );
};

export default ReportsWrapper;
